/**
 * scheduleCapacity.ts — heatmap band thresholds for the weekly capacity cells.
 *
 * Wave 3 (percent retirement) + IMP2-1 (audit #2): employee capacity is the
 * BINARY PERSON-DAY model — a working day is simply busy or free, an
 * assignment is presence (its stored Percent is pinned to 100 and ignored by
 * readers), and the weekly figure is percent-of-week = busyDays ÷ workingDays
 * (holiday-aware). The one remaining HARD signal is a task landing on a day
 * off (`hasOverbook`, Q3B).
 *
 *   - Backend truth:  backend/src/calculation/personDayModel.ts
 *   - FE mirror:      frontend/src/utils/personDayDisplay.ts (day states +
 *                     weekBusyPercent / weekPercentFromCell)
 *
 * The retired per-day-percent constants (CAPACITY_PER_DAY, MAX_ENTRY_PERCENT,
 * WORKING_DAYS_PER_WEEK) were deleted with the model — only the display band
 * cut-offs below remain, consumed by CapacityHeatmapCell.
 */

/**
 * Heatmap bands for the weekly percent-of-week figure (0–100, can exceed 100
 * on a conflict week):
 *   ≤ 0          → noActivity (grey)
 *   1 – 70%      → heatmapLow  (green)
 *   71 – 100%    → heatmapMid  (yellow)
 *   > 100%       → heatmapHigh (red)
 * Independent of the day-off conflict flag — a low-percent cell still flags
 * red ⚠ when a task lands on a day off.
 */
export const HEATMAP_LOW_MAX = 70;  // top of the green band (% of week busy)
export const HEATMAP_MID_MAX = 100; // top of the yellow band (% of week busy)
